import Swiper from 'swiper/dist/js/swiper';
import * as helpers from '../helpers';

export default function initCarousels() {
    const carousels = new Swiper('.js-swiper', {
        init: false,
        simulateTouch: false,
        watchOverflow: true,
        loop: false,
        autoplay: false,
        speed: 500,
        a11y: {
            enabled: false,
        },
        pagination: {
            type: 'bullets',
            bulletElement: 'li',
            clickable: true,
            bulletClass: 'swiper-pagination__bullet',
            bulletActiveClass: '-is-active',
            renderBullet: (index, className) => {
                return `
                        <li class="${className}" role="presentation">
                            <button class="swiper-pagination__bullet-btn" role="tab" aria-selected="false">
                                <span class="ghost">${index + 1}</span>
                            </button>
                        </li>
                        `;
            },
        },
    });

    const setCarouselWraps = (carouselInstance) => {
        const carouselContainer = carouselInstance.el;

        let carouselWrapper;
        for (let i = 0; i < carouselContainer.children.length; i++) {
            if (helpers.hasClass(carouselContainer.children[i], 'swiper-wrapper')) {
                carouselWrapper = carouselContainer.children[i];
            }
        }

        const carouselSlides = carouselWrapper.children;
        const carouselParentWrapper = carouselContainer.parentNode;
        const carouselArrows = carouselParentWrapper.querySelectorAll('button.-prev, button.-next');

        helpers.addClass(carouselContainer, 'swiper-container');

        for (let i = 0; i < carouselSlides.length; i++) {
            helpers.addClass(carouselSlides[i], 'swiper-slide');
        }

        for (let i = 0; i < carouselArrows.length; i++) {
            helpers.addClass(carouselArrows[i], 'js-swiper-control');
        }
    };

    const setControlsDisplay = (carouselInstance, state) => {
        const controls = carouselInstance.el.parentNode.querySelectorAll('.js-swiper-control');
        for (let i = 0; i < controls.length; i++) {
            const control = state
                ? helpers.addClass(controls[i], '-is-hidden')
                : helpers.removeClass(controls[i], '-is-hidden');
        }
    };

    const setControlsState = (carouselInstance) => {
        if (carouselInstance && carouselInstance.el && carouselInstance.el.parentNode) {
            const controls = carouselInstance.el.parentNode.querySelectorAll('.js-swiper-control');
            for (let i = 0; i < controls.length; i++) {
                const state = helpers.hasClass(controls[i], 'swiper-button-disabled');
                const control = state
                    ? controls[i].setAttribute('disabled', 'disabled')
                    : controls[i].removeAttribute('disabled');
            }
        }
    };

    const setNavigation = (carouselInstance) => {
        const instanceData = carouselInstance.el.dataset;
        let buttonNext;
        let buttonPrev;

        if (instanceData.outsideNavigation === 'true') {
            buttonNext = carouselInstance.el.parentNode.querySelector('button.-next');
            buttonPrev = carouselInstance.el.parentNode.querySelector('button.-prev');
        } else {
            buttonNext = carouselInstance.el.querySelector('button.-next');
            buttonPrev = carouselInstance.el.querySelector('button.-prev');
        }

        carouselInstance.params.navigation.nextEl = buttonNext;
        carouselInstance.params.navigation.prevEl = buttonPrev;
    };

    const setBulletsAccessibility = (carouselInstance) => {
        const pagination = carouselInstance.el.parentNode.querySelector('.swiper-pagination');
        const bullets = pagination.querySelectorAll('.swiper-pagination__bullet .swiper-pagination__bullet-btn');
        const activeBullet = pagination.querySelector('.swiper-pagination__bullet.-is-active .swiper-pagination__bullet-btn');

        if (bullets !== null) {
            for (let j = 0; j < bullets.length; j++) {
                bullets[j].setAttribute('aria-selected', false);
                bullets[j].setAttribute('tabindex', -1);
            }

            if (activeBullet !== null) {
                activeBullet.setAttribute('aria-selected', true);
                activeBullet.setAttribute('tabindex', 0);
            }
        }
    };

    const setBulletEvent = (bullet) => {
        bullet.addEventListener('keydown', (event) => {
            const activeElement = event.target.parentNode;
            const firstElement = activeElement.parentNode.firstElementChild;
            const lastElement = activeElement.parentNode.lastElementChild;

            if (!event.ctrlKey && !event.shiftKey && event.keyCode !== 9) {
                if (event.keyCode === 37 || event.keyCode === 38) {
                    if (activeElement === firstElement) {
                        lastElement.click();
                        setTimeout(() => {
                            lastElement.querySelector('button').focus();
                        }, 0);
                    } else {
                        activeElement.previousElementSibling.click();
                        setTimeout(() => {
                            activeElement.previousElementSibling.querySelector('button').focus();
                        }, 0);
                    }
                } else if (event.keyCode === 39 || event.keyCode === 40) {
                    if (activeElement === lastElement) {
                        firstElement.click();
                        setTimeout(() => {
                            firstElement.querySelector('button').focus();
                        }, 0);
                    } else {
                        activeElement.nextElementSibling.click();
                        setTimeout(() => {
                            activeElement.nextElementSibling.querySelector('button').focus();
                        }, 0);
                    }
                } else if (event.keyCode === 36) {
                    firstElement.click();
                    setTimeout(() => {
                        firstElement.querySelector('button').focus();
                    }, 0);
                } else if (event.keyCode === 35) {
                    lastElement.click();
                    setTimeout(() => {
                        lastElement.querySelector('button').focus();
                    }, 0);
                }
                event.preventDefault();
            }
        });
    };

    const setBreakpoints = (carouselInstance) => {
        const instanceData = { ...carouselInstance.el.dataset };
        const breakpoints = {};

        let itemsPerView;
        let itemsToSlide;

        for (const data in instanceData) {
            if (Object.prototype.hasOwnProperty.call(instanceData, data)) {
                if (data === 'autoplay') {
                    if (instanceData[data] === 'false') {
                        carouselInstance.params.autoplay = false;
                    } else {
                        carouselInstance.params.autoplay.enabled = true;
                        carouselInstance.params.autoplay.delay = isNaN(Number(instanceData[data]))
                            ? 0
                            : Number(instanceData[data]);
                    }
                }

                if (data === 'effect') {
                    carouselInstance.params.effect = instanceData[data];
                    carouselInstance.params.fadeEffect.crossFade = true;
                }

                if (data === 'loop') {
                    carouselInstance.params.loop = instanceData[data] !== 'false';
                }

                if (data === 'items') {
                    itemsPerView = instanceData[data].split(', ');
                }

                if (data === 'slideByOne') {
                    itemsToSlide = instanceData[data] === true;
                }

                if (data === 'pagination') {
                    let pagination;

                    if (instanceData[data] === 'outside') {
                        pagination = carouselInstance.el.parentNode.querySelector('.swiper-pagination');
                    } else {
                        pagination = carouselInstance.el.querySelector('.swiper-pagination');
                    }

                    if (pagination !== null) {
                        carouselInstance.params.pagination.el = pagination;
                        carouselInstance.pagination.render();


                        setTimeout(() => {
                            const bullets = [].slice.call(pagination.querySelectorAll('.swiper-pagination__bullet'));

                            setBulletsAccessibility(carouselInstance);
                            bullets.forEach(bullet => setBulletEvent(bullet));
                        }, 100);
                    }
                }

                if (itemsPerView === undefined) {
                    breakpoints['4000'] = {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                    };
                } else {
                    switch (itemsPerView.length) {
                        case 1:
                            breakpoints['4000'] = {
                                slidesPerView: itemsPerView[0],
                                slidesPerGroup: itemsToSlide === undefined ? itemsPerView[0] : 1,
                            };
                            break;
                        case 2:
                            breakpoints['1279'] = {
                                slidesPerView: itemsPerView[1],
                                slidesPerGroup: itemsToSlide === undefined ? itemsPerView[1] : 1,
                            };
                            breakpoints['4000'] = {
                                slidesPerView: itemsPerView[0],
                                slidesPerGroup: itemsToSlide === undefined ? itemsPerView[0] : 1,
                            };
                            break;
                        case 3:
                            breakpoints['767'] = {
                                slidesPerView: itemsPerView[2],
                                slidesPerGroup: itemsToSlide === undefined ? itemsPerView[2] : 1,
                            };
                            breakpoints['1279'] = {
                                slidesPerView: itemsPerView[1],
                                slidesPerGroup: itemsToSlide === undefined ? itemsPerView[1] : 1,
                            };
                            breakpoints['4000'] = {
                                slidesPerView: itemsPerView[0],
                                slidesPerGroup: itemsToSlide === undefined ? itemsPerView[0] : 1,
                            };
                            break;
                        default:
                            breakpoints['4000'] = {
                                slidesPerView: 1,
                                slidesPerGroup: 1,
                            };
                            break;
                    }
                }
            }
        }

        return breakpoints;
    };

    const setSlidesAccessibility = (carouselInstance, activeIndex) => {
        const slides = carouselInstance.el.querySelectorAll('.swiper-slide');
        const slidesToShow = carouselInstance.params.breakpoints;
        const screenWidth = window.innerWidth;
        const loopMode = carouselInstance.params.loop;
        let slideActive = carouselInstance.el.querySelector(`.swiper-slide-active[data-swiper-slide-index="${activeIndex}"]`);
        let stateCounter = true;

        if (slideActive === null && loopMode) {
            slideActive = carouselInstance.el.querySelector('.swiper-slide-active[data-swiper-slide-index="0"]');
        }

        for (const view in slidesToShow) {
            if (screenWidth <= Number(view)) {
                if (slides.length > slidesToShow[view].slidesPerView && stateCounter) {
                    stateCounter = false;
                    // Add aria-hidden to all slides
                    for (let i = 0; i < slides.length; i++) {
                        slides[i].setAttribute('aria-hidden', true);
                        helpers.setTabindex(slides[i], -1);
                    }

                    const itemsMustShow = slidesToShow[view].slidesPerView;

                    for (let i = 0; i < itemsMustShow; i++) {
                        if (loopMode) {
                            const slidesArray = [].slice.call(slides);
                            const realIndex = slidesArray.indexOf(slideActive);

                            slideActive.setAttribute('aria-hidden', false);
                            slidesArray[realIndex + i].setAttribute('aria-hidden', false);
                            helpers.setTabindex(slideActive, 0);
                            helpers.setTabindex(slidesArray[realIndex + i], 0);
                        } else {
                            slides[activeIndex].setAttribute('aria-hidden', false);
                            slides[activeIndex + i].setAttribute('aria-hidden', false);
                            helpers.setTabindex(slides[activeIndex], 0);
                            helpers.setTabindex(slides[activeIndex + i], 0);
                        }
                    }
                }
            }
        }
    };

    const manageAutoplayState = (carouselInstance, state) => {
        const actionsContainer = carouselInstance.el.parentNode.querySelector('.swiper-actions');
        const play = actionsContainer.querySelector('.js-swiper-play');
        const pause = actionsContainer.querySelector('.js-swiper-pause');

        // reset state
        play.setAttribute('aria-hidden', true);
        pause.setAttribute('aria-hidden', true);
        helpers.removeClass(pause, '-is-active');
        helpers.removeClass(play, '-is-active');

        if (state) {
            pause.setAttribute('aria-hidden', false);
            helpers.addClass(pause, '-is-active');
            // pause.focus();
        } else {
            play.setAttribute('aria-hidden', false);
            helpers.addClass(play, '-is-active');
            // play.focus();
        }
    };

    const checkCarouselBeforeInit = (carouselInstance, breakpoints) => {
        const screenWidth = window.innerWidth;
        const instanceSlides = carouselInstance.el.querySelectorAll('.swiper-slide').length;

        setControlsDisplay(carouselInstance, true);

        if (!helpers.hasClass(carouselInstance.el, 'swiper-container-horizontal')) {
            carouselInstance.init();
        }

        for (const item in breakpoints) {
            if (screenWidth <= Number(item)) {
                if (instanceSlides > breakpoints[item].slidesPerView) {
                    setControlsDisplay(carouselInstance, false);
                    setControlsState(carouselInstance);
                }
            }
        }
    };

    // Init all carousel instances
    [].concat(carousels || []).filter(carousel => !!carousel.el).forEach((carousel) => {
        carousel.params.breakpoints = setBreakpoints(carousel);
        setNavigation(carousel);
        setCarouselWraps(carousel);

        checkCarouselBeforeInit(carousel, setBreakpoints(carousel));

        carousel.on('init', () => {
            if (carousel.params.pagination.el) {
                setBulletsAccessibility(carousel);
            }
            setSlidesAccessibility(carousel, carousel.realIndex);
            setControlsState(carousel);
        });

        window.addEventListener('resize', () => {
            setSlidesAccessibility(carousel, carousel.realIndex);
            checkCarouselBeforeInit(carousel, setBreakpoints(carousel));
        });
    });

    const carouselInstances = document.querySelectorAll('.js-swiper');

    for (let i = 0; i < carouselInstances.length; i++) {
        const instance = carouselInstances[i].swiper;
        const play = instance.el.parentNode.querySelector('.js-swiper-play');
        const pause = instance.el.parentNode.querySelector('.js-swiper-pause');
        let autoplayState = instance.autoplay.running;

        instance.on('slideChange', () => {
            if (instance.params.pagination.el) {
                setBulletsAccessibility(instance);
            }
            setControlsState(instance);
        });

        instance.on('slideChangeTransitionEnd', () => {
            setSlidesAccessibility(instance, instance.realIndex);

            if (pause) {
                if (!instance.autoplay.running && helpers.hasClass(pause, '-is-active')) {
                    instance.autoplay.start();
                }
            }
        });

        if (play !== null && pause !== null) {
            manageAutoplayState(instance, autoplayState);

            play.addEventListener('click', () => {
                instance.autoplay.start();
                autoplayState = instance.autoplay.running;
                manageAutoplayState(instance, autoplayState);
            });

            pause.addEventListener('click', () => {
                instance.autoplay.stop();
                autoplayState = instance.autoplay.running;
                manageAutoplayState(instance, autoplayState);
            });
        }
    }
}
